module.exports = __webpack_public_path__ + "img/Palletised Freight.ebaef77.jpg";